export default {
  resetLabel: 'Clear refinements',
};
